// extracted by mini-css-extract-plugin
export default {"cardAuditInfoContainer":"RecentBlogs_cardAuditInfoContainer__FQkWz","cardAuditInfo":"RecentBlogs_cardAuditInfo__i0iYP","auditInfoText":"RecentBlogs_auditInfoText__Fjgvl"};